import { get, post } from '../../http'
import {
  ZHIBO_URL,
  HOMEMINIURI,
  MARKET_URL,
  LIVE_GW_URL,
  FIXUP_URL,
  LIVE_PALY_URL,
} from '../../baseUrl'

// H5-课程详情 与 课程信息 接口
export function getCourseDetail(params) {
  return get(`${ZHIBO_URL}/course_service/v1/course/h5/detail`, params, true, {
    zhibo: true,
    allResolve: true,
  })
}
// H5-课程-拥有列表
export function postCoursePossessList(params, loading) {
  return post(
    `${ZHIBO_URL}/course_service/v1/course/possess/list`,
    params,
    loading,
    { zhibo: true }
  )
}
// H5-音频手动切换上下集
export function postExchangeChapter(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/chapter/before_and_after`,
    params,
    false,
    { zhibo: true }
  )
}
// H5-课节-详情
export function postChapterDetail(params) {
  return post(`${ZHIBO_URL}/course_service/v1/chapter/detail`, params, true, {
    zhibo: true,
    allResolve: true,
  })
}
// H5-课节-拥有列表
export function postChapterPossessList(params, loading) {
  return post(
    `${ZHIBO_URL}/course_service/v1/chapter/possess/list`,
    params,
    loading,
    { zhibo: true }
  )
}
// H5-获取课节关联的课程
export function postChapterCourseList(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/course_chapter/list_course`,
    params,
    true,
    { zhibo: true }
  )
}
// H5-获取直播间配置
export function getSiteInfo(params) {
  return get(`${LIVE_PALY_URL}/api/live/get_site_info`, params, false)
}
// H5-根据课程ID查课节分页列表
export function postCourseChapterList(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/chapter/page_by_course_id`,
    params,
    false,
    { zhibo: true }
  )
}
// 学员领取课程
export function postCourseAddStudent(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/student_asset/receive_course`,
    params,
    true,
    { zhibo: true }
  )
}
// 学员领取课节
export function postChapterAddStudent(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/student_asset/receive_chapter`,
    params,
    true,
    { zhibo: true }
  )
}
// H5-课程资料
export function postCourseMaterial(params) {
  return post(`${ZHIBO_URL}/course_service/v1/course/material`, params, true, {
    zhibo: true,
  })
}
// H5-课节资料
export function postChapterMaterial(params) {
  return post(`${ZHIBO_URL}/course_service/v1/chapter/material`, params, true, {
    zhibo: true,
  })
}
// 获取课程或课节关联的考试和作业
export function getHomeworkExamCount(params) {
  return get(
    `${ZHIBO_URL}/course_service/v1/listAssetEaxmWork`,
    params,
    false,
    { zhibo: true }
  )
}
// 分页获取课程的作业列表
export function postHomeworkCourseList(params, loading) {
  return post(
    `${ZHIBO_URL}/v1/homework/get_course_homework_list`,
    params,
    loading,
    { zhibo: true }
  )
}
// 是否开启推广
export function getSalesManGeneralize(params) {
  return get(`${HOMEMINIURI}/api/Generalize/WxSalesmanGeneralize`, params)
}
// 推广员-与客户创建关系
export function postGeneralizeCustom(params) {
  return post(`${HOMEMINIURI}/api/Generalize/Custom`, params)
}
// 详情页获取优惠券列表
export function postCouponListFromDetail(params) {
  return post(
    `${MARKET_URL}/api/v1/coupon/GetCouponListFromDetail`,
    params,
    false
  )
}
// 领取优惠券
export function postReceiveCoupon(params) {
  return post(`${MARKET_URL}/api/v1/coupon/GetCoupon`, params)
}
// H5-专题详情 与 专题信息 接口
export function postSpecialDetail(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/special_topic/h5/detail`,
    params,
    true,
    {
      zhibo: true,
      allResolve: true,
    }
  )
}
// H5-根据专题ID查课程分页列表
export function postSpecialCoursePage(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/special_topic/page_by_special_topic_id`,
    params,
    true,
    {
      zhibo: true,
    }
  )
}
// H5专题拥有列表
export function postSpecialCourseList(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/special_topic/h5/page_possess`,
    params,
    true,
    {
      zhibo: true,
    }
  )
}
// H5-专题资料
export function postSpecialMaterial(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/special_topic/material`,
    params,
    true,
    {
      zhibo: true,
    }
  )
}
// H5-专题-通过课程id获取课节列表
export function postSpecialCourseChapter(params) {
  return get(
    `${ZHIBO_URL}/course_service/v1/chapter/list_by_course_id`,
    params,
    false,
    {
      zhibo: true,
    }
  )
}
// H5专题详情密码校验
export function postCheckSpecialPwd(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/authority/check_special_topic_pwd`,
    params,
    true,
    {
      zhibo: true,
    }
  )
}
// H5课节详情密码校验
export function postCheckChapterPwd(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/authority/check_chapter_pwd`,
    params,
    true,
    {
      zhibo: true,
    }
  )
}
// H5课程详情密码校验
export function postCheckCoursePwd(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/authority/check_course_pwd`,
    params,
    true,
    {
      zhibo: true,
    }
  )
}
// 学员领取专题
export function postReceiveSpecial(params) {
  return post(
    `${ZHIBO_URL}/course_service/v1/student_asset/receive_special_topic`,
    params,
    true,
    {
      zhibo: true,
    }
  )
}
// 防录屏跑马灯-服务是否开通
export function getIsCarousel(params) {
  return get(
    `${LIVE_GW_URL}/incrservice/v1/admin/incrRecord/isOpen`,
    params,
    true,
    {
      zhibo: true,
    }
  )
}

// 获取防录屏跑马灯配置
export function getCarouselConfig(params) {
  return get(
    `${LIVE_GW_URL}/incrservice/v1/admin/horseRaceLamp/getConfig`,
    params,
    false,
    {
      zhibo: true,
    }
  )
}

// 判断课程课节订单
export function judgeCourseOrder(params) {
  return get(`${ZHIBO_URL}/course_service/v1/course/is_course`, params, true, {
    zhibo: true,
  })
}

// 通用课节查询接口
export function postCommonChapterList(params, loading = false) {
  return post(
    `${LIVE_GW_URL}/train/v1/common/course_service/chapter/cardList`,
    params,
    loading,
    { zhibo: true }
  )
}
export function postCommonCourseList(params, loading = false) {
  return post(
    `${LIVE_GW_URL}/train/v1/common/course_service/course/cardList`,
    params,
    loading,
    { zhibo: true }
  )
}
export function postCommonSpecialList(params, loading = false) {
  return post(
    `${LIVE_GW_URL}/train/v1/common/course_service/special_topic/cardList`,
    params,
    loading,
    { zhibo: true }
  )
}
export function postCommomCampList(params, loading = false) {
  return post(
    `${LIVE_GW_URL}/train/v1/common/course_service/train_camp/cardList`,
    params,
    loading,
    { zhibo: true }
  )
}
export function getShopMoveAttr(params) {
  return get(
    `${FIXUP_URL}/api/v1/public/SiteInfo/get_shop_move_attr`,
    params,
    false
  )
}
export function topicFromCourseReport(params, loading = false) {
  return post(
    `${ZHIBO_URL}/course_service/v1/chapter/view_live_video`,
    params,
    loading,
    { zhibo: true }
  )
}
export function getStudentAssetList(params, loading) {
  return post(
    `${ZHIBO_URL}/course_service/v1/student_asset/get_studentAsset_List`,
    params,
    loading,
    { zhibo: true }
  )
}

/**
 * 获取课程分享信息
 */
export function getCourseShareInfo(params, loading = false) {
  return post(
    `${ZHIBO_URL}/course_service/v1/content_receive/getShareOutSideVo`,
    params,
    loading,
    {
      zhibo: true,
    }
  )
}

/**
 * 获取分享者课程分享信息
 */
export function getSharerCourseShareInfo(params, loading = false) {
  return post(
    `${ZHIBO_URL}/course_service/v1/content_receive/receiverGetShare`,
    params,
    loading,
    {
      zhibo: true,
    }
  )
}

/**
 * 领取分享的课程
 */
export function postReceiveShareCourse(params, loading = false) {
  return post(
    `${ZHIBO_URL}/course_service/v1/content_receive/saveShareReceive`,
    params,
    loading,
    {
      zhibo: true,
    }
  )
}
export function getTrainConfig(params, loading) {
  return get(`${ZHIBO_URL}/course_service/v1/system/config`, params, loading, {
    zhibo: true,
    noToken: true,
  })
}
// 查看评论列表
export function getCommentList(params, loading) {
  return post(
    `${ZHIBO_URL}/course_service/v1/comment/page_comment`,
    params,
    loading,
    { zhibo: true }
  )
}
// 获取二级评论列表
export function getChildCommentList(params, loading) {
  return post(
    `${ZHIBO_URL}/course_service/v1/comment/page_child_comment`,
    params,
    loading,
    { zhibo: true }
  )
}
// 更新点赞状态
export function updateLikeState(params, loading) {
  return post(
    `${ZHIBO_URL}/course_service/v1/comment/update_like_state`,
    params,
    loading,
    { zhibo: true }
  )
}
// 删除评论
export function deleteComment(params, loading) {
  return post(
    `${ZHIBO_URL}/course_service/v1/comment/del_comment`,
    params,
    loading,
    { zhibo: true }
  )
}
// 获取教培配置
export function getTrainContentConfig(params, loading) {
  return post(
    `${ZHIBO_URL}/course_service/v1/course/getTrainContentConfig`,
    params,
    loading,
    { zhibo: true }
  )
}
// 回复或者评论
export function replyAndComment(params, loading) {
  return post(
    `${ZHIBO_URL}/course_service/v1/comment/reply_comment`,
    params,
    loading,
    { zhibo: true, allRes: true }
  )
}

/**
 * 获取课程的播放模式信息
 */
export function getCoursePlayMode(params, loading = false) {
  return get(
    `${ZHIBO_URL}/course_service/v1/course/get_user_dir_play`,
    params,
    loading,
    {
      zhibo: true,
    }
  )
}

/**
 * 保存课程的播放模式信息
 */
export function postCoursePlayMode(params, loading = false) {
  return post(
    `${ZHIBO_URL}/course_service/v1/course/user_dir_play `,
    params,
    loading,
    {
      zhibo: true,
    }
  )
}

/**
 * 训练营课节下一节
 */
export function getTrainCampNextChapter(params, loading = false) {
  return post(`${ZHIBO_URL}/v1/period/period_next_chapter`, params, loading, {
    zhibo: true,
  })
}

/**
 * 获取话题关联的知识培训内容
 */
export function getTrainRelation(params, loading = false) {
  return get(
    `${ZHIBO_URL}/course_service/v1/course/zbTopic/relation`,
    params,
    loading,
    {
      zhibo: true,
    }
  )
}

/**
 * 获取关联知识课程列表
 */
export function getChapterCourseList(params, loading = false) {
  return get(
    `${ZHIBO_URL}/course_service/v1/chapter/h5/chapterCourseList`,
    params,
    loading,
    {
      zhibo: true,
    }
  )
}
